// @ts-ignore
import {
    orderImporterGetLockers,
    orderImporterCreateOrders,
} from '../../../helpers/restHelpers'
import {
    Button,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    makeStyles,
    Box,
    Container,
    Paper,
    TablePagination,
} from '@material-ui/core/index'
import React, { useEffect, useState } from 'react'
import { read, utils } from 'xlsx'
import {
    ErrorSheet,
    Locker,
    OrderProcessedToSave,
    OrderImportedFromXLS,
} from './interfaces'
import {
    calculateDoorSizeText,
    cleanRowErrores,
    processOrderAddress,
    processOrderLocker,
} from './functions'
import ImportSheetTable from '../../components/ImportSheetTable'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { ErrorModal, SuccessModal } from '../../components/modals'
import { ResumeFile,ResumeResponse } from './resume'
import Loader from '../../loaders'
import { saveAsExcel } from '../../components/saveAsExcel'
import { downloadOrdersTemplate } from '../orders/orderTemplates'
import { connect } from 'react-redux'
import { ReplaceQuotes } from '../../../utils/formaters'
// Caracteres especiales
// import { ReplaceNotAlowedCharacters } from '../../../utils/formaters'

const useStyles = makeStyles({
    inputContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dropZone: {
        width: '210px',
        height: '110px',
        border: '1px dashed #f7b500',
        textAlign: 'center',
        padding: '20px',
        borderRadius: '5px',
        fontSize: '16px',
        position: 'relative',
    },
    uploadIcon: {
        transform: 'scale(1.5)',
    },
    uploadText: {
        margin: '10px',
    },
    input: {
        width: '252px',
        height: '152px',
        position: 'absolute',
        opacity: 0,
        top: 0,
        left: 0,
    },
    inputFileBtn: {
        fontSize: '12px',
        backgroundColor: '#f7b500',
        borderRadius: '20px',
    },
    btnContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    sendBtn: {
        width: '210px',
        height: '40px',
        marginTop: '20px',
        marginRight: '15px',
        backgroundColor: '#f7b500',
        color: '#fff',
        borderColor: '#f7b500',

        '&:hover': {
            borderColor: '#f7b500',
            color: '#f7b500',
            backgroundColor: '#fff',
        },
    },
    downloadBtn: {
        width: '210px',
        height: '40px',
        marginTop: '20px',
        borderColor: '#f7b500',
        color: '#f7b500',
        '&:hover': {
            backgroundColor: '#f7b500',
            color: '#fff',
        },
    },
    downloadErrorsBtn: {
        width: '320px',
        height: '40px',
        backgroundColor: '#f7b500',
        color: '#fff',
        borderColor: '#f7b500',
        marginLeft: '15px',
        marginTop: '20px',
        '&:hover': {
            borderColor: '#f7b500',
            backgroundColor: '#fff',
            color: '#f7b500',
        },
    },
    table: {
        margin: '50px auto',
    },
    tableHead: {
        position: 'sticky',
        border: 'none',
        top: 0,
        left: 0,
        zIndex: 2,
    },
    tableRow: {
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    spinner: {
        color: '#f7b500',
        marginTop: '30px',
    },
    textAlert: {
        display: 'flex',
        color: '#FF0000',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    orderFailed: {
        marginTop: '20px',
        padding: '20px',
        backgroundColor: '#f8eac3',
        fontSize: '16px',
        lineHeight: '20px',
    },
    orderSuccessful: {
        marginTop: '20px',
        padding: '20px',
        backgroundColor: '#c3f8ca',
        fontSize: '16px',
        lineHeight: '20px',
    },
    orderImported: {
        marginTop: '20px',
        padding: '20px',
        backgroundColor: '#f4f3f3',
        fontSize: '16px',
        lineHeight: '20px',
    },
})


const ImportSheetFile = (store : any) => {
    const styles = useStyles()
    // @ts-ignore
    let errors: Array<ErrorSheet> = []
    const [lockers, setLockers] = useState<Locker[]>()
    const [orders, setOrders] = useState<OrderImportedFromXLS[]>()
    const [ordersToSave, setOrdersToSave] = useState<OrderProcessedToSave[]>()
    const [importError, setImportError] = useState<ErrorSheet[]>()
    const [errorSheet, setErrorSheet] = useState(false)
    const [showSaveOrdersButton, setShowSaveOrdersButton] = useState(false)

    const [loading, setLoading] = useState(false)
    const [limit, setLimit] = useState(false)
    const [successDialog, setSuccessDialog] = useState(false)
    const [errorDialog, setErrorDialog] = useState(false)
    const [errorMessages, setErrorMessages] = useState<ErrorSheet[]>()
    const [fileError, setFileError] = useState(false)
    const [ordersWithErrors, setOrdersWithErrors] = useState<OrderImportedFromXLS[]>([])

    const orderCustomSecurity = store.appStore.userPermissions.some((x:any) => x === 'orderCustomSecurity')

    useEffect(() => {
        const fetchLockers = async () => {
            // @ts-ignore
            setLockers(await orderImporterGetLockers())
        }
        fetchLockers().then(() => {
        })
    }, [])

    let uploadErrors: ErrorSheet[] = []

    const saveOrders = async () => {
        setShowSaveOrdersButton(false)
        setOrdersWithErrors([])
        setLoading(true)
        const response = await orderImporterCreateOrders(ordersToSave)
        if (response.data.length === 0) {
            setSuccessDialog(true)
        }
        for (let i = 0; i < response.data.length; i++) {
            const result = response.data[i].result
            if (result.length && orders) {
                setErrorDialog(true)
                uploadErrors.push({ row: i + 1, message: result })
                for (let j = 0; j < orders.length; j++) {
                    if (String(orders.indexOf(orders[j])+1) === response.data[i].rowNumber ) {
                        ordersWithErrors.push(orders[j])                        
                    }
                }
            } 
        }
        setErrorMessages(uploadErrors)
        setLoading(false)
        setOrders(ordersWithErrors)
        setOrdersWithErrors(ordersWithErrors)
    }
    const handleImport = ($event: any) => {
        setOrders([])
        setOrdersWithErrors([])
        setErrorDialog(false)
        setSuccessDialog(false)
        setImportError([])
        setErrorMessages([])
        setLimit(false)
        setErrorSheet(false)
        setOrdersToSave([])
        cleanRowErrores()
        setOrders([])
        setShowSaveOrdersButton(true);
        setLoading(true);
        setPage(0)
        setFileError(false)
        const files = $event.target.files
        if (lockers && lockers.length > 0 && files.length) {
            const file = files[0]
            const reader = new FileReader()
            reader.onload = (event) => {
                // @ts-ignore
                const wb = read(event.target.result)
                const sheets = wb.SheetNames

                if (sheets.length) {
                    const rows = utils.sheet_to_json(wb.Sheets[sheets[0]])
                    if (rows.length > 100) {
                        setLimit(true)
                    }
                    // @ts-ignore
                    let ordersToSave = verifyImport(rows)
                    ReplaceQuotes(ordersToSave)
                    ReplaceQuotes(rows)

                    // Caracteres especiales
                    // ReplaceNotAlowedCharacters(ordersToSave)
                    // ReplaceNotAlowedCharacters(rows)
                    
                    setOrdersToSave(ordersToSave)
                    // @ts-ignore
                    setOrders(rows)
                    setLoading(false);
                }
            }
            reader.readAsArrayBuffer(file)
        }
        $event.target.value = null
    }

    const handleCheck = (idLocker: number) => {
        // @ts-ignore
        return lockers.some((locker) => idLocker === locker.id)
    }
    const verifyImport = (
        orders: OrderImportedFromXLS[]
    ): OrderProcessedToSave[] | undefined => {

        if(orders[0] && Object.keys(orders[0])[0] !== "ClientMail" ) {
            setFileError(true)
        }

        try {
            let rowNumber: number = 1
            let orderHasError: boolean = false
            let ordersToSave: OrderProcessedToSave[] = []
            let data: any = {}
            data.errors = []
            let customCodeTypeId : number | undefined = undefined

            orders.forEach((order: OrderImportedFromXLS) => {
                let requestSignature : string | undefined = order.RequestSignature ? String(order.RequestSignature).toLowerCase() : undefined
                let requestToken : string | undefined = order.RequestToken ? String(order.RequestToken).toLowerCase() : undefined
                order.ClientPhone = !order.ClientPhone
                    ? ''
                    : order.ClientPhone.toString()
                order.DepositCode = order.DepositCode === '' 
                    ? null
                    : order.DepositCode
                if (order.LockerId) {
                    // @ts-ignore
                    data = processOrderLocker(order, rowNumber)
                    if (!data.doorSize) {
                        orderHasError = true
                        data.errors.push({
                            message: `Las medidas del paquete son incorrectas`,
                            row: rowNumber,
                        })
                    }
                    if (!handleCheck(order.LockerId)) {
                        orderHasError = true
                        data.errors.push({
                            message: `El locker '${order.LockerId}' no es válido`,
                            row: rowNumber,
                        })
                    }
                    if (String(order.CustomCodeType!).toLowerCase() === 'dni' || order.CustomCodeType === '2') {
                        customCodeTypeId = 2
                    } else if (String(order.CustomCodeType!).toLowerCase() === 'alphanumeric' || order.CustomCodeType === '3') { 
                        customCodeTypeId = 3
                    } else if (order.CustomCodeType === '' || order.CustomCodeType === undefined) {
                        customCodeTypeId = undefined 
                    } else {
                        orderHasError = true
                        data.errors.push({
                            message: `El tipo de código de seguridad no es válido.`,
                            row: rowNumber,
                        })
                    }
                    if(order.CustomCode && !order.CustomCodeType){
                        orderHasError = true
                        data.errors.push({
                            message: `El tipo de código de seguridad no es válido.`,
                            row: rowNumber,
                        })
                    }
                    if(order.CustomCodeType && !order.CustomCode){
                        orderHasError = true
                        data.errors.push({
                            message: `El código de seguridad no es válido.`,
                            row: rowNumber,
                        })
                    }
                    if(requestSignature !== 'true' && requestSignature !== 'false' && requestSignature !== undefined ){
                        orderHasError = true
                        data.errors.push({
                            message: `El campo RequestSignature es invalido.`,
                            row: rowNumber,
                        })
                    }
                    if(requestToken !== 'true' && requestToken !== 'false' && requestToken !== undefined){
                        orderHasError = true
                        data.errors.push({
                            message: `El campo RequestToken es invalido.`,
                            row: rowNumber,
                        })
                    }
                    if(!orderCustomSecurity && (order.RequestSignature || order.RequestToken || order.CustomCode || order.CustomCodeType)){
                        orderHasError = true
                        data.errors.push({
                            message: `No tiene permiso para solicitar código de seguridad.`,
                            row: rowNumber,
                        })
                    }
                    if (
                        data.errors &&
                        data.errors.length === 0 &&
                        !orderHasError
                    ) {
                        let orderToSave: OrderProcessedToSave = {
                            Alias: order.Alias,
                            ClientName: order.ClientName,
                            RowNumber: rowNumber,
                            ClientMail: order.ClientMail,
                            ClientPhone: order.ClientPhone,
                            DoorSizeId: data.doorSize,
                            LockerId: order.LockerId,
                            DepositCode: order.DepositCode,
                            CustomSecurity: {
                                RequestSignature: order.RequestSignature,
                                RequestToken: requestToken,
                                CustomCode: {
                                    Type: customCodeTypeId,
                                    Code: order.CustomCode,
                                },
                            }
                        }
                        ordersToSave.push(orderToSave)
                    }
                } else {
                    data.errors = processOrderAddress(order, rowNumber)
                    if (errors && errors.length === 0 && !orderHasError) {
                        let orderToSave: OrderProcessedToSave = {
                            Alias: order.Alias,
                            ClientName: order.ClientName,
                            ClientMail: order.ClientMail,
                            ClientPhone: order.ClientPhone,
                            RowNumber: rowNumber,
                            DepositCode: order.DepositCode,
                            ClientData: {
                                StreetName: order.StreetName,
                                StreetNumber: order.StreetNumber,
                                Floor: order.Floor,
                                City: order.City,
                                CountrySubdivision: order.CountrySubdivision,
                                PostalCode: order.PostalCode,
                                Apartment: order.Apartment,
                                Locality: order.Locality,
                            },
                        }
                        ordersToSave.push(orderToSave)
                    }
                }
                if (data.errors && data.errors.length > 0) {
                    setImportError(data.errors)
                    setErrorSheet(true)
                } else {
                    setImportError([])
                    setErrorSheet(false)
                }
                rowNumber++
            })
            if (!orderHasError) {
                return ordersToSave
            } else {
                return []
            }
        } catch (e) {
            console.error(e)
        }
    }

    const rowsWithErrors = new Set()
    if (importError){
        importError.forEach(error => {
            rowsWithErrors.add(error.row)
        })
    }

    //-- Pagination

    const [page, setPage] = useState(0)
    const rowsPerPage = 50

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage)
    }

    // @ts-ignore

    const someDepositCode: boolean = !orders
        ? false
        : orders.some(
            (x: OrderImportedFromXLS) =>
                x.DepositCode && x.DepositCode.length > 0
        )
    const isMobile: boolean = window.innerWidth < 900

    return (
        <Container>
            <>
                <Box marginTop={'50px'} className={styles.inputContainer}>
                    <div className={styles.dropZone}>
                        <label htmlFor="inputFile" >
                            <CloudUploadIcon className={styles.uploadIcon} />
                            <p className={styles.uploadText}>
                                Arrastre su archivo aquí o{' '}
                            </p>
                            <Button
                                variant="contained"
                                component="span"
                                disableElevation
                                className={styles.inputFileBtn}
                            >
                                Seleccionar archivo
                            </Button>
                            <input
                                type="file"
                                name="file"
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                id="inputFile"
                                onChange={handleImport}
                                required
                                className={styles.input}
                                draggable
                            />
                        </label>
                    </div>
                </Box>
                <Box className={styles.btnContainer}>
                    {orders && orders.length && showSaveOrdersButton ? (
                        <Button
                            onClick={saveOrders}
                            variant="outlined"
                            component="span"
                            className={styles.sendBtn}
                            disabled={errorSheet}
                        >
                            Enviar órdenes
                        </Button>
                    ) : null}
                    <Button
                        onClick={() => saveAsExcel([], 'Plantilla ejemplo de órdenes Pudo', downloadOrdersTemplate(orderCustomSecurity), Object.keys(downloadOrdersTemplate(orderCustomSecurity)), orderCustomSecurity)}
                        variant="outlined"
                        component="span"
                        className={styles.downloadBtn}
                    >
                        Descargar plantilla
                    </Button>
                    {ordersWithErrors && ordersWithErrors.length ?
                        <Button
                            onClick={() => saveAsExcel(orders, 'Ordenes no creadas', downloadOrdersTemplate(orderCustomSecurity), Object.keys(downloadOrdersTemplate(orderCustomSecurity)), orderCustomSecurity)}
                            variant="outlined"
                            component="span"
                            className={styles.downloadErrorsBtn}
                        >
                            Descargar ordenes no creadas
                        </Button>
                        : null}
                </Box>
                {successDialog && ordersToSave ? (
                    <>
                        <SuccessModal />
                        <ResumeResponse  total={ordersToSave!.length} />
                    </>
                ) : null}
                {errorDialog && errorMessages ? (
                    <>
                        <ErrorModal errorMessage={errorMessages} />
                        <ResumeResponse total={ordersToSave!.length} errors={errorMessages.length} />
                    </>
                ) : null}
            </>
            {loading ? <Loader /> : (
                <div className="row">
                    <div>
                        {orders  && fileError ? (
                                <ResumeFile fileError={true}/>
                        ) :
                        orders && orders.length > 0 && !limit ? (
                            <>
                                {!successDialog && !errorDialog ? (
                                    <ResumeFile
                                        total={orders ? orders.length : 0}
                                        errors={importError ? rowsWithErrors.size : 0}
                                    />
                                ) : null}
                                <Paper>
                                    <TableContainer className={styles.table}>
                                        <Table className="table">
                                            <TableHead
                                                className={styles.tableHead}
                                            >
                                                <TableRow>
                                                    <TableCell style={{ paddingLeft: 0, paddingRight: 0, }}>{''}</TableCell>

                                                    {isMobile ? <>
                                                        <TableCell>Metodo De Envío</TableCell>
                                                        <TableCell>Correo{' '}{someDepositCode ? ' o código' : null}</TableCell>
                                                    </> : null}

                                                    {!isMobile ? <>
                                                        <TableCell>Metodo De Envío</TableCell>
                                                        <TableCell>Correo</TableCell>
                                                        <TableCell>Nombre</TableCell>
                                                        <TableCell>Teléfono</TableCell>
                                                        <TableCell>Código</TableCell>
                                                    </> : null}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(rowsPerPage > 0
                                                    ? orders.slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage +
                                                        rowsPerPage
                                                    )
                                                    : orders
                                                ).map((order, index) => (
                                                    <ImportSheetTable
                                                        key={index}
                                                        rowNumber={index + page * rowsPerPage}
                                                        order={order}
                                                        DoorSizeId={calculateDoorSizeText(
                                                            order
                                                        )}
                                                        allLockers={lockers!}
                                                        importErrors={
                                                            importError
                                                        }
                                                        saveErrors={errorMessages}
                                                        orderCustomSecurity={orderCustomSecurity}
                                                    />
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[]}
                                            component="div"
                                            count={orders.length}
                                            page={page}
                                            rowsPerPage={rowsPerPage}
                                            onChangePage={handleChangePage}
                                        />
                                    </TableContainer>
                                </Paper>
                            </>
                        ) : orders && orders.length === 0 && ordersWithErrors.length === 0 && !ordersToSave!.length ? (
                            <ResumeFile/>
                        ) : orders && orders.length !== 0 && limit ? (
                            <ResumeFile rowsOverflow={100}/>
                        ) : null}
                    </div>
                </div>
            )}
        </Container>
    )
}

const mapStateToProps = (store : any)  => {
    return {
        appStore: store.app
    }
}

export default  connect(mapStateToProps)(ImportSheetFile)